
import { defineComponent, ref } from 'vue';

import InjectStyles from '@/common/components/InjectStyles.vue';
import Notifications from '@/common/components/Notifications.vue';
import { setupComponent } from '@/classifications/composables/setupComponent';
import { ComponentName } from '@/classifications/api/configuration/components/ComponentName';

export default defineComponent({
  name: ComponentName.notifications,

  components: {
    InjectStyles,
    Notifications,
  },

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { componentName, isReady, isWebComponent, instance, store, routeData } = setupComponent(
      root,
      props.instanceId,
    );

    return {
      root,
      store,
      isReady,
      instance,
      routeData,
      componentName,
      isWebComponent,
    };
  },
});
